import { useState } from "react";
import { submitContact } from "../lib/api";
import { Mail, Phone, MapPin, MessageCircle } from "lucide-react";
import { SUPPORT_EMAIL, waLink } from "../constants/data";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) return toast.error("Please complete all required fields");
    setLoading(true);
    try {
      await submitContact(form);
      toast.success("Message sent! We'll reach out shortly.");
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch { toast.error("Failed to send"); }
    finally { setLoading(false); }
  };

  return (
    <div className="pt-32 pb-20" data-testid="contact-page">
      <section className="container-x">
        <p className="label-small">Get in Touch</p>
        <h1 className="font-serif text-5xl text-[#2D2424] mt-3">Let's create something thoughtful together</h1>
        <p className="text-[#5C5555] mt-4 max-w-2xl">Have a special occasion in mind? Bulk order questions? Or just want to say hello — we'd love to hear from you.</p>

        <div className="mt-12 grid lg:grid-cols-2 gap-12">
          <div className="space-y-6">
            <div className="flex gap-4 bg-white border border-[#E5DBD8] p-5">
              <Phone className="w-5 h-5 text-[#7A1F2B] mt-1" strokeWidth={1.5}/>
              <div>
                <p className="font-serif text-lg text-[#2D2424]">Call / WhatsApp</p>
                <p className="text-sm text-[#5C5555]">+91 93460 42323</p>
                <p className="text-xs text-[#5C5555] mt-1">10 AM – 7 PM</p>
              </div>
            </div>
            <div className="flex gap-4 bg-white border border-[#E5DBD8] p-5">
              <Mail className="w-5 h-5 text-[#7A1F2B] mt-1" strokeWidth={1.5}/>
              <div>
                <p className="font-serif text-lg text-[#2D2424]">Email</p>
                <a href={`mailto:${SUPPORT_EMAIL}`} className="text-sm text-[#5C5555] hover:text-[#7A1F2B]">{SUPPORT_EMAIL}</a>
              </div>
            </div>
            <div className="flex gap-4 bg-white border border-[#E5DBD8] p-5">
              <MapPin className="w-5 h-5 text-[#7A1F2B] mt-1" strokeWidth={1.5}/>
              <div>
                <p className="font-serif text-lg text-[#2D2424]">Based in</p>
                <p className="text-sm text-[#5C5555]">Hyderabad, India</p>
              </div>
            </div>
            <a href={waLink("Hi! I have a question about your hampers.")} target="_blank" rel="noreferrer" data-testid="contact-whatsapp-btn" className="btn-whatsapp w-full justify-center">
              <MessageCircle className="w-4 h-4"/> Quick Chat on WhatsApp
            </a>
          </div>

          <form onSubmit={submit} className="bg-white border border-[#E5DBD8] p-6" data-testid="contact-form">
            <h3 className="font-serif text-2xl text-[#2D2424]">Send a Message</h3>
            {["name","email","phone"].map((k) => (
              <input key={k} placeholder={k === "phone" ? "Phone (optional)" : k[0].toUpperCase()+k.slice(1)} value={form[k]} onChange={(e) => setForm({...form, [k]: e.target.value})} data-testid={`contact-${k}`} className="mt-4 w-full border border-[#E5DBD8] px-4 py-3 text-sm focus:outline-none focus:border-[#7A1F2B]"/>
            ))}
            <textarea rows={5} placeholder="Your message" value={form.message} onChange={(e) => setForm({...form, message: e.target.value})} data-testid="contact-message" className="mt-4 w-full border border-[#E5DBD8] px-4 py-3 text-sm focus:outline-none focus:border-[#7A1F2B]"/>
            <button type="submit" disabled={loading} data-testid="contact-submit" className="btn-primary w-full mt-5">{loading ? "Sending…" : "Send Message"}</button>
          </form>
        </div>
      </section>
    </div>
  );
}
